import React, { Component } from 'react';
import App from "../../App";
import { Button, Col, Form, Row } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { add, getAreas, getDetails, getLocations, updateDwh, getThanas } from "../../services/baseServices";
import { Select } from 'antd';

class Edit extends Component {
  constructor() {
    super();
    this.state = {
      formData: {},
      warehouseInfo: {},
      isFormValidated: false,
      isLoadingData: true,
      isSubmitting: false,
      districts: [],
      thanas: [],
      areas: [],
      thanaVisibility: true,
      areaVisibility: true,
      warehouseDistricts: []
    };
  };

  componentDidMount() {
    getDetails("warehouses", this.props.match.params.id)
      .then(res => {
        const formData = { ...this.state.formData };
        formData.bn_name = res.bn_name
        formData.name = res.name
        formData.email = res.email
        formData.phone = res.phone
        formData.address_line = res.address.address_line
        formData.bn_address_line = res.address.bn_address_line
        formData.district_id = res.address.district_id
        formData.thana_id = res.address.thana_id
        formData.area_id = res.address.area_id
        formData.public_visibility = res.public_visibility
        formData.is_commission_applicable = res.is_commission_applicable
        formData.districts = res.districts?.map(i=>i.name)
        
        this.setState({formData, warehouseInfo: res}, () => {
          this.setState({warehouseDistricts: formData.districts})
          getLocations('districts')
            .then(res => {
              this.setState({districts: res})
            })
            .catch(errMsg => {
            })

          if (this.state.formData.district_id !== undefined) {
            getThanas({district_id: this.state.formData.district_id})
              .then(res => {
                this.setState({thanas: res, thanaVisibility: false})
              })
              .catch(errMsg => {
              })
            getAreas({thana_id: this.state.formData.thana_id})
              .then(res => {
                this.setState({areas: res, areaVisibility: false})
              })
              .catch(errMsg => {
              })
          }
        })
      })
      .catch(errMsg => {
        console.log('Err Msg: ', errMsg)
      });
  }

  handleInputOnChange = (e) => {
    const formData = { ...this.state.formData };
    formData[e.target.name] = e.target.value;
    this.setState({ formData }, () => {
      console.log(this.state.formData);
    });
  }
  callThanas = district_id => {
    getThanas({district_id: district_id})
      .then(res => {
        this.setState({thanas: res, thanaVisibility: false})
      })
      .catch(errMsg => {
      })
  }
  callAreas = thana_id => {
    getAreas({thana_id: thana_id})
      .then(res => {
        this.setState({areas: res, areaVisibility: false})
      })
      .catch(errMsg => {
      })
  }
  handleUpdateDwh = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({ isFormValidated: true })
    } else {
      this.setState({ isSubmitting: true }, () => {
        const formData = { ...this.state.formData }
        if(formData.districts?.length <1){
          toast.error('Select districts first')
          this.setState({ isSubmitting: false })
          return
        }

        // formData.address_attributes = {
        //   address_line: formData.address_line,
        //   bn_address_line: formData.bn_address_line,
        //   district_id: parseInt(formData.district_id),
        //   thana_id: parseInt(formData.thana_id),
        //   area_id: parseInt(formData.area_id),
        // }

        delete formData.district_id;
        delete formData.thana_id;

        updateDwh("warehouses", this.props.match.params.id, "warehouse", formData)
          .then(res => {
            this.props.history.push(`/dwh/list`);
            toast.success("Warehouse has been updated successfully");
          })
          .catch(errMsg => {
            toast.error(errMsg);
            this.setState({ isSubmitting: false })
          });
      })
    }
  }
  handleDistrictsSelect = (e) => {
    const formData = { ...this.state.formData }
    let selectedDistrict = [];
    this.state.districts.some(r => {
      if (e.includes(r.name)) {
        selectedDistrict.push(r.name)
      }
    })
    formData.districts = selectedDistrict;
    this.setState({ formData: formData })
  }
  render() {
    const { formData, warehouseDistricts } = this.state;
    const districtOptions =
      this.state.districts.length > 0 &&
      this.state.districts.map((item) => {
        return {
          key: item.name,
          id: item.id,
          dwh_assigned: item.dwh_assigned
        }
      })
      ;
    let selectedDistrictList = [];
    formData.districts && formData.districts.length > 0 && this.state.districts.length > 0 && formData.districts.forEach((item) => {
      selectedDistrictList.push(item)
    })

    return (
      <App layout="boxed">
        <div className="page-header">
          <h2 className="page-title">Edit Distribution House</h2>
        </div>

        <div className="card-block">
          <div className="block-body">
            <>
              <Form
                noValidate
                validated={this.state.isFormValidated}
                onSubmit={this.handleUpdateDwh}>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Warehouse Name
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"name"}
                      defaultValue={this.state.formData?.name}
                      onChange={this.handleInputOnChange}
                      type="text" />
                    <Form.Control.Feedback type="invalid">Please enter warehouse name
                      name.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm="3">Commission Applicable<span className="text-danger">*</span></Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <label className="sr-only">Commission Applicable</label>
                    <select id="schedule" name="is_commission_applicable" className='form-control' onChange={this.handleInputOnChange} value={this.state.formData?.is_commission_applicable}>
                      <option value="">--Select--</option>
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Name in Bangla
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"bn_name"}
                      defaultValue={this.state.formData?.bn_name}
                      onChange={this.handleInputOnChange}
                      type="text"
                    />
                    <Form.Control.Feedback type="invalid">Please enter warehouse name in bangla
                      name.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Email
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      disabled="disabled"
                      name={"email"}
                      defaultValue={this.state.formData?.email}
                      onChange={this.handleInputOnChange}
                      type="text" />
                    <Form.Control.Feedback type="invalid">Please enter email.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Password
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"password"}
                      onChange={this.handleInputOnChange}
                      type="password" />
                    <Form.Control.Feedback type="invalid">Please enter password.</Form.Control.Feedback>
                    <i className="text-help text-muted text-danger">Please keep this field blank if you don't want to
                      change the password.</i>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Confirm Password
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"password_confirmation"}
                      onChange={this.handleInputOnChange}
                      type="password" />
                    <Form.Control.Feedback type="invalid">Please repeat password.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Phone no.
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"phone"}
                      defaultValue={this.state.formData?.phone}
                      onChange={this.handleInputOnChange}
                      type="text" />
                    <Form.Control.Feedback type="invalid">Please enter phone.</Form.Control.Feedback>
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="branding_button_url">
                  <Form.Label column sm="3">
                    Covering Districts <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Select
                      disabled
                      mode="multiple"
                      size="large"
                      placeholder="Select Districts filter options"
                      value={selectedDistrictList && selectedDistrictList.length > 0 && selectedDistrictList}
                      // value={selectedFilteringAttributes}
                      onChange={this.handleDistrictsSelect}
                      style={{ width: '100%' }}
                    >
                      {districtOptions && districtOptions.map((item) => (
                        <Select.Option key={item.key} disabled={item.dwh_assigned === true && !warehouseDistricts?.includes(item.key)}>
                          {item.key}
                        </Select.Option>
                      ))}
                    </Select>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    FC District <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      required
                      name="district_id"
                      onChange={e => {
                        const formData = {...this.state.formData};
                        formData[e.target.name] = e.target.value;
                        this.setState({formData})
                        this.callThanas(e.target.value);
                      }}
                      as="select" type="text">
                      <option value="">--Select District--</option>
                      {this.state.districts.length > 0 ?
                        this.state.districts.map((item) => {
                          return (
                            <option value={item.id} selected={item.id === this.state.formData.district_id}>{item.name}</option>
                          )
                        })
                        : ""
                      }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">Please enter address.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    FC Thana <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      required
                      disabled={this.state.thanaVisibility}
                      name="thana_id"
                      onChange={e => {
                        const formData = {...this.state.formData};
                        formData[e.target.name] = e.target.value;
                        this.setState({formData})
                        this.callAreas(e.target.value);
                      }}
                      as="select" type="text">
                      <option value="">--Select Thana--</option>
                      {this.state.thanas.length > 0 ?
                        this.state.thanas.map((item) => {
                          return (
                            <option value={item.id} selected={item.id === this.state.formData.thana_id}>{item.name}</option>
                          )
                        })
                        : ""
                      }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">Please enter address.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    FC Area <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      required
                      disabled={this.state.areaVisibility}
                      name="area_id"
                      onChange={this.handleInputOnChange}
                      as="select" type="text"
                    >
                      <option value="">--Select Area--</option>
                      {this.state.areas.length > 0 ?
                        this.state.areas.map((item) => {
                          return (
                            <option value={item.id} selected={item.id === this.state.formData.area_id}>
                              {item.name}
                            </option>
                          )
                        })
                        : ""
                      }
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">Please enter address.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Address <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"address_line"}
                      onChange={this.handleInputOnChange}
                      defaultValue={this.state.formData?.address_line}
                      required
                      type="text" />
                    <Form.Control.Feedback type="invalid">Please enter address.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="displayOrShopName">
                  <Form.Label column sm="3">
                    Address in Bangla <span className="text-danger">*</span>
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      name={"bn_address_line"}
                      defaultValue={this.state.formData?.bn_address_line}
                      onChange={this.handleInputOnChange}
                      required
                      type="text" />
                    <Form.Control.Feedback type="invalid">Please enter address.</Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="public_visibility">
                  <Form.Label column sm="3">
                    Public Visibility
                  </Form.Label>
                  <Col sm="9" md={8} lg={7}>
                    <Form.Control
                      required
                      name="public_visibility"
                      value={this.state.formData?.public_visibility}
                      onChange={this.handleInputOnChange}
                      as="select"
                      type="text"
                    >
                      <option value={true}>True</option>
                      <option value={false}>False</option>
                    </Form.Control>
                  </Col>
                </Form.Group>
                <div className="mt-3">
                  <Button
                    size="lg" type={"submit"}
                    disabled={this.state.isSubmitting}
                    variant="primary">{this.state.isSubmitting ? 'Updating...' : 'Update'}
                  </Button>
                </div>
              </Form>
            </>
          </div>
        </div>
      </App>
    );
  }
}

export default withRouter(Edit);
